import React from 'react';

import RemoteAccessAuditConfigurationContainer from '@totem/components/services/remoteAccess/auditConfiguration/RemoteAccessAuditConfigurationContainer';
import RemoteAccessAuditConfigurationContent from '@totem/components/services/remoteAccess/auditConfiguration/RemoteAccessAuditConfigurationContent';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

import './auditConfiguration.css';

const RemoteAccessAuditConfigurationPage = () => {
  return (
    <ContentLayout>
      <RemoteAccessAuditConfigurationContainer>
        <IBCard isCovered>
          <RemoteAccessAuditConfigurationContent />
        </IBCard>
      </RemoteAccessAuditConfigurationContainer>
    </ContentLayout>
  );
};

export default RemoteAccessAuditConfigurationPage;
